import {
  BuildValidSystemsInputContext,
  buildValidSystemsInput
} from 'components/watchers/valid-systems-input';
import { buildPoolHash } from 'components/watchers/valid-systems-pool-hash';
import { CondenserType } from 'data/types';
import { defaultDataState } from 'features/data/data-slice';
import { deriveHybridDuctedSpaceIds } from 'utils/hybrid-config-autobuild';
import { isHybridOnlySystemPreference } from 'utils/project';
import { ValidSystemsInputStateSource } from 'utils/valid-systems-input-context-types';

export function validSystemsInputContextFromState(
  state: ValidSystemsInputStateSource
): BuildValidSystemsInputContext {
  const structure = Array.isArray(state.structure?.structure)
    ? state.structure.structure
    : [];
  const autoLayoutSpaceIds = state.structure?.autoLayoutSpaceIds ?? [];
  const systemPreference = state.project?.projectSettings?.find(
    (setting) => setting.code === 'system_preference'
  )?.value;
  return {
    structure,
    supplementalHeatingWeight:
      state.data?.supplementalHeatingWeight ??
      defaultDataState.supplementalHeatingWeight,
    supplementalCoolingWeight:
      state.data?.supplementalCoolingWeight ??
      defaultDataState.supplementalCoolingWeight,
    emitDuctedZoneFlags: isHybridOnlySystemPreference(systemPreference),
    leftoverSpaceIds: new Set(
      deriveHybridDuctedSpaceIds(structure, autoLayoutSpaceIds)
    )
  };
}

export function currentPoolHashOf(
  condenser: CondenserType,
  context: BuildValidSystemsInputContext
): string | null {
  const input = buildValidSystemsInput(condenser, context);
  return input ? buildPoolHash(input) : null;
}
